import { useState, useEffect } from "react";

export enum Breakpoints {
    xs = 320, // Extra small (small phones, starting from iPhone 5/SE)
    sm = 576, // Small (phones landscape, larger phones)
    md = 768, // Medium (tablets, small laptops)
    lg = 992, // Large (desktops)
    xl = 1200, // Extra large (large desktops)
    xxl = 1440, // Extra extra large (very large screens)
}

const desktopQuery = window.matchMedia(`(min-width: ${Breakpoints.lg + 1}px)`);
const laptopQuery = window.matchMedia(
    `(min-width: ${Breakpoints.md}px) and (max-width: ${Breakpoints.lg}px)`
);
const mobileQuery = window.matchMedia(`(max-width: ${Breakpoints.md - 1}px)`);

export type UseMediaResult = {
    isMobile: boolean;
    isLaptop: boolean;
    isDesktop: boolean;
};

export function useMedia(): UseMediaResult {
    const [state, setState] = useState<UseMediaResult>(() => ({
        isMobile: mobileQuery.matches,
        isLaptop: laptopQuery.matches,
        isDesktop: desktopQuery.matches,
    }));

    useEffect(() => {
        const handleChange = () => {
            setState({
                isMobile: mobileQuery.matches,
                isLaptop: laptopQuery.matches,
                isDesktop: desktopQuery.matches,
            });
        };

        handleChange();

        mobileQuery.addEventListener("change", handleChange);
        laptopQuery.addEventListener("change", handleChange);
        desktopQuery.addEventListener("change", handleChange);

        return () => {
            mobileQuery.removeEventListener("change", handleChange);
            laptopQuery.removeEventListener("change", handleChange);
            desktopQuery.removeEventListener("change", handleChange);
        };
    }, []);

    return state;
}
